// Generated by scripts/mdi/import-questionnaires.mjs.
import mdiAlopeciaMinoxidilQuestions from './AlopeciaMinoxidil/questions';
import mdiB12InjectionIntakeQuestions from './B12InjectionIntake/questions';
import mdiB12RefillQuestions from './B12Refill/questions';
import mdiBPC157Questions from './BPC157/questions';
import mdiBPC157ThymosinBeta4Questions from './BPC157ThymosinBeta4/questions';
import mdiCJC1295IpamorelinQuestions from './CJC1295Ipamorelin/questions';
import mdiEmideltideDSIPQuestions from './EmideltideDSIP/questions';
import mdiEpithalonQuestions from './Epithalon/questions';
import mdiErectileDysfunctionInitialQuestions from './ErectileDysfunctionInitial/questions';
import mdiErectileDysfunctionRefillQuestions from './ErectileDysfunctionRefill/questions';
import mdiFinasterideDutasterideWomensMENQuestions from './FinasterideDutasterideWomensMEN/questions';
import mdiGlutathioneInitialQuestions from './GlutathioneInitial/questions';
import mdiGlutathioneRefillQuestions from './GlutathioneRefill/questions';
import mdiKPVQuestions from './KPV/questions';
import mdiMOTSCQuestions from './MOTSC/questions';
import mdiMinoxidilFinasterideBiotinMenWomenQuestions from './MinoxidilFinasterideBiotinMenWomen/questions';
import mdiMinoxidilFinasterideMenWomenQuestions from './MinoxidilFinasterideMenWomen/questions';
import mdiMinoxidilFinasterideTretMenWomenQuestions from './MinoxidilFinasterideTretMenWomen/questions';
import mdiNADInitialQuestions from './NADInitial/questions';
import mdiNADRefillQuestions from './NADRefill/questions';
import mdiPT141BremelanotideInjectionMenAndWomenQuestions from './PT141BremelanotideInjectionMenAndWomen/questions';
import mdiSemaglutideB6InitialQuestions from './SemaglutideB6Initial/questions';
import mdiSemaglutideB6RefillQuestions from './SemaglutideB6Refill/questions';
import mdiSermorelinRefillQuestions from './SermorelinRefill/questions';
import mdiStandardizedSermorelinIntakeQuestions from './StandardizedSermorelinIntake/questions';
import mdiTesamorelinInitialSystemicQuestions from './TesamorelinInitialSystemic/questions';
import mdiTesamorelinRefillSystemicQuestions from './TesamorelinRefillSystemic/questions';
import mdiThymosinBeta4Questions from './ThymosinBeta4/questions';
import mdiTirzepatideB6InitialQuestions from './TirzepatideB6Initial/questions';
import mdiTirzepatideB6RefillQuestions from './TirzepatideB6Refill/questions';

const mdiQuestions = [
  ...mdiAlopeciaMinoxidilQuestions,
  ...mdiB12InjectionIntakeQuestions,
  ...mdiB12RefillQuestions,
  ...mdiBPC157Questions,
  ...mdiBPC157ThymosinBeta4Questions,
  ...mdiCJC1295IpamorelinQuestions,
  ...mdiEmideltideDSIPQuestions,
  ...mdiEpithalonQuestions,
  ...mdiErectileDysfunctionInitialQuestions,
  ...mdiErectileDysfunctionRefillQuestions,
  ...mdiFinasterideDutasterideWomensMENQuestions,
  ...mdiGlutathioneInitialQuestions,
  ...mdiGlutathioneRefillQuestions,
  ...mdiKPVQuestions,
  ...mdiMOTSCQuestions,
  ...mdiMinoxidilFinasterideBiotinMenWomenQuestions,
  ...mdiMinoxidilFinasterideMenWomenQuestions,
  ...mdiMinoxidilFinasterideTretMenWomenQuestions,
  ...mdiNADInitialQuestions,
  ...mdiNADRefillQuestions,
  ...mdiPT141BremelanotideInjectionMenAndWomenQuestions,
  ...mdiSemaglutideB6InitialQuestions,
  ...mdiSemaglutideB6RefillQuestions,
  ...mdiSermorelinRefillQuestions,
  ...mdiStandardizedSermorelinIntakeQuestions,
  ...mdiTesamorelinInitialSystemicQuestions,
  ...mdiTesamorelinRefillSystemicQuestions,
  ...mdiThymosinBeta4Questions,
  ...mdiTirzepatideB6InitialQuestions,
  ...mdiTirzepatideB6RefillQuestions
];

export default mdiQuestions;
